<i18n src="./resources/locales.json"></i18n>

<template>
  <div :class="{ transition: email.isReplying }">
    <EcsEmailHeader
      :email="email"
      :disabled="isEmailHistoric"
      :business-process-id="businessProcessId"
      @updateToEmails="onUpdateToEmails"
      @updateCcEmails="onUpdateCcEmails"
      @updateBccEmails="onUpdateBccEmails"
      @updateSubject="onSubjectUpdate"
      @updateFromEmail="onUpdateFromEmail"
      @updateRequiredBccEmails="onUpdateRequiredBccEmails"
    />
    <div class="quill-container">
      <EcsQuillEditor
        ref="quill"
        class="pa-2"
        :value="email.outgoingEmailData.body"
        :disabled="isEmailHistoric"
        @input="onQuillChange"
      >
        <template #custom-buttons>
          <div class="d-flex flex-row">
            <CannedResponses
              v-if="activeElementId.length"
              :element-id="activeElementId"
              :height="28"
              :width="28"
              x-small
              @canned-response="handleCannedResponse"
            />
          </div>
        </template>
      </EcsQuillEditor>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsQuillEditor from '@/components/ecs-quill-editor/EcsQuillEditor';
import EcsEmailHeader from '@/components/ecs-email/ecs-email-header/EcsEmailHeader';
import CannedResponses from '@/components/ecs-interaction/CannedResponses';
import InteractionService from '@/services/interactionService';
import emailUtil from '@/utils/email';

export default {
  name: 'EcsEmailReply',
  components: { EcsQuillEditor, EcsEmailHeader, CannedResponses },
  props: {
    email: {
      type: Object,
      required: true
    },
    isEmailHistoric: {
      type: Boolean,
      default: false
    },
    activeElementId: {
      type: String,
      default: ''
    },
    businessProcessId: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('AGENT', ['loggedInAgent'])
  },
  methods: {
    onQuillChange(payload) {
      this.$emit('quillChange', payload);
    },
    onUpdateToEmails(emails) {
      this.$emit('updateToEmails', emails);
    },
    onUpdateCcEmails(emails) {
      this.$emit('updateCcEmails', emails);
    },
    onUpdateBccEmails(emails) {
      this.$emit('updateBccEmails', emails);
    },
    onUpdateRequiredBccEmails(emails) {
      this.$emit('updateRequiredBccEmails', emails);
    },
    onSubjectUpdate(value) {
      this.$emit('updateSubject', value);
    },
    onUpdateFromEmail(value) {
      this.$emit('updateFromEmail', value);
      const signatureFunction = this.email.isIncomingEmail
        ? InteractionService.getReplyEmailSignature
        : InteractionService.getOutgoingEmailSignature;
      signatureFunction(this.businessProcessId, value)
        .then(signature => {
          const index =
            this.email.outgoingEmailData.signatureIndex > 0 ? this.email.outgoingEmailData.signatureIndex : 0;
          if (this.$refs.quill) {
            const formatted = emailUtil.getEmailSignatureFormatted(this.email, signature.data, this.loggedInAgent.name);
            this.$refs.quill.replaceSignature({ index }, formatted);
          }
        })
        .catch(() => {
          this.$root.$emit('snackbar-message', {
            message: this.$t('errorRetrieveSignature'),
            type: 'error'
          });
        });
    },
    handleCannedResponse(cannedResponse) {
      let cursorPosition = this.$refs.quill.getCursorPosition();
      let text = cannedResponse.text;
      if (!cursorPosition) {
        const index =
          this.email.outgoingEmailData.signatureIndex > 0 ? this.email.outgoingEmailData.signatureIndex - 1 : 0;
        cursorPosition = { index };
        text = `${text}<br><br>`;
      }
      this.$refs.quill.insertTextAtCursorPosition(cursorPosition, text);
    }
  }
};
</script>

<style scoped>
.quill-container {
  width: 100%;
  height: 100%;
}
.canned-responses {
  display: flex;
  justify-content: flex-end;
  margin-right: 8px;
}
.transition {
  height: 0px;
  -webkit-animation: grow 1s forwards;
  animation: grow 1s forwards;
  animation-timing-function: ease-out;
}

@-webkit-keyframes grow {
  25% {
    height: 50px;
  }
  50% {
    height: 100px;
  }
  75% {
    height: 150px;
  }
  100% {
    height: fit-content;
  }
}

@keyframes grow {
  25% {
    height: 50px;
    overflow: hidden;
  }
  50% {
    height: 100px;
    overflow: hidden;
  }
  75% {
    height: 150px;
    overflow: hidden;
  }
  100% {
    height: fit-content;
  }
}
</style>
